import "./styles.css";
import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  LayersControl,
  LayerGroup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

function DraggableMarker({ position, setPosition, setMapPoint }) {
  const customIcon = new L.Icon({
    iconUrl: `./images/markerMap2.svg`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

  const updatePosition = (e) => {
    const marker = e.target;
    const newLatLng = marker.getLatLng();
    setPosition([newLatLng.lat, newLatLng.lng]);
    setMapPoint([newLatLng.lat, newLatLng.lng]);
  };

  return (
    <Marker
      position={position}
      draggable={true}
      icon={customIcon}
      eventHandlers={{ dragend: updatePosition }}
    />
  );
}

function MapWithMarker({ setMapPoint, initialPosition }) {
  const [position, setPosition] = useState(
    initialPosition ? initialPosition : [32.018373, 53.311462]
  );

  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);
      setMapPoint([lat, lng]);
    },
    // moveend(e) {
    //   const map = e.target;
    //   const center = map.getCenter();
    //   setPosition([center.lat, center.lng]);
    //   setMapPoint([center.lat, center.lng]);
    // },
  });

  return (
    <DraggableMarker
      position={position}
      setPosition={setPosition}
      setMapPoint={setMapPoint}
    />
  );
}

export default function MapPoint({ setMapPoint, mapPoint }) {
  const defaultPosition = [32.018373, 53.311462];
  const centerPosition =
    mapPoint && mapPoint[0] !== null && mapPoint[1] !== null
      ? mapPoint
      : defaultPosition;

  return (
    <MapContainer
      center={centerPosition}
      zoom={5}
      scrollWheelZoom
      style={{ height: "50vh", marginLeft: "100px", zIndex: "50" }}
    >
      <LayersControl position="topright">
        <LayersControl.BaseLayer checked name="نقشه OpenStreetMap">
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </LayersControl.BaseLayer>

        <LayersControl.BaseLayer name="نقشه Google">
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
          />
        </LayersControl.BaseLayer>

        <LayerGroup>
          <MapWithMarker
            setMapPoint={setMapPoint}
            initialPosition={centerPosition}
          />
        </LayerGroup>
      </LayersControl>
    </MapContainer>
  );
}
